const isDev = process.env.NODE_ENV !== 'production';

const Logger = {
    log: (...args) => {
        if (isDev) console.log(...args);
    },

    warn: (...args) => {
        if (isDev) console.warn(...args);
    },

    error: (...args) => {
        // error'ları production'da da görmek isteyebilirsin
        console.error(...args);
    },

    info: (...args) => {
        if (isDev) console.info(...args);
    },

    debug: (...args) => {
        if (isDev) console.debug(...args);
    }
};

export default Logger;


// WEBPACK FOOTER //
// ./app/helpers/logger.js